import { Box, Button, Modal, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { generateResponsiveStyle } from "../../utils/modalStyle";

type props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleDelete: () => void;
  name: string;
  status: string;
};

const RefundModal = ({ open, setOpen, handleDelete, name, status }: props) => {
  const style = generateResponsiveStyle();

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ textAlign: "center", fontSize: "19px" }}
        >
          Are you sure you want to {status} this {name}?
        </Typography>
        <div className="flexdiv">
          <Button
            className="yesBtn"
            onClick={() => {
              setOpen(false);
              handleDelete();
            }}
          >
            Yes
          </Button>

          <Button
            sx={{ color: "black", border: "1px solid black" }}
            onClick={() => setOpen(false)}
          >
            No
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default RefundModal;
